import { render, staticRenderFns } from "./HostHosGtest1.vue?vue&type=template&id=59b910a5&scoped=true&"
import script from "./HostHosGtest1.vue?vue&type=script&lang=js&"
export * from "./HostHosGtest1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b910a5",
  null
  
)

export default component.exports